/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_Send_CodeInputs */

const en_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Verification Code`)
};

const de_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungscode senden`)
};

const fr_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer le code de vérification`)
};

const es_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar código de verificación`)
};

const it_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia Codice di Verifica`)
};

const nl_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificatiecode verzenden`)
};

const pl_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij kod weryfikacyjny`)
};

const fi_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä Vahvistuskoodi`)
};

const da_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send bekræftelseskode`)
};

const sv_onboarding_verify_send_code = /** @type {(inputs: Onboarding_Verify_Send_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka verifieringskod`)
};

/**
* | output |
* | --- |
* | "Send Verification Code" |
*
* @param {Onboarding_Verify_Send_CodeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_send_code = /** @type {((inputs?: Onboarding_Verify_Send_CodeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_Send_CodeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_send_code(inputs)
	if (locale === "fr") return fr_onboarding_verify_send_code(inputs)
	if (locale === "es") return es_onboarding_verify_send_code(inputs)
	if (locale === "it") return it_onboarding_verify_send_code(inputs)
	if (locale === "nl") return nl_onboarding_verify_send_code(inputs)
	if (locale === "pl") return pl_onboarding_verify_send_code(inputs)
	if (locale === "fi") return fi_onboarding_verify_send_code(inputs)
	if (locale === "da") return da_onboarding_verify_send_code(inputs)
	if (locale === "sv") return sv_onboarding_verify_send_code(inputs)
	return en_onboarding_verify_send_code(inputs)
});